'use client';

import { useState } from 'react';
import { useRouter } from 'next/navigation';
import { InnocodeButton, InnocodeList, useDialog, useInnocodeOverlayMenu, useModal } from '@intsoft/innocode-core';
import styles from './AdminNavbar.module.css';
import { Platform } from '../layout/AdminLayout';
import { adminMenuList, MenuItem } from '../../../router/menu_list';

interface AdminNavbarProps {
  closeMobileMenu?: () => void;
  platform: Platform,
  currentPageUrl: string;
}


export default function AdminNavbar({ closeMobileMenu, platform, currentPageUrl }: AdminNavbarProps) {
  const router = useRouter();
  const { showDialog } = useDialog();
  const { showOverlayMenu } = useInnocodeOverlayMenu();
  const { showInnocodeModal } = useModal();

  // 1depth 메뉴가 active인지 확인 (홈은 정확히 /, 상품은 /products 또는 /products/*)
  const isMenuActive = (menu: MenuItem) => {
    if (!menu.pageSlug) return false;
    if (menu.pageSlug === '/') return currentPageUrl === '/';
    if (menu.slugPattern) return false;
    return currentPageUrl === menu.pageSlug || currentPageUrl.startsWith(menu.pageSlug + '/');
  };

  const handlePageMove = (pageSlug: string) => { 
    if (pageSlug) { 
      router.push(pageSlug);

      closeMobileMenu?.();
    }

  };
  return (
    <div className={styles.navbarWrapper + " " + ((platform === Platform.MOBILE || platform === Platform.TABLET) ? styles.mobileOpen : '')}>

      <div className={styles.navbarContainer}>
        {(platform === Platform.MOBILE || platform === Platform.TABLET) && (
          <div className={styles.mobileNavbarHeaderContainer}> 
            <a href="/"><img src="/assets/images/logo-blue.png" alt="logo" className={styles.logo}></img></a>
          </div>
        )} 
        <div className={styles.menuContainer}>
          {adminMenuList.map((menu: MenuItem) => {
            const isActive = isMenuActive(menu);
            if (!menu.showMenu) {
              return null;
            }
            return (
              <div
                key={menu.pageName}
                className={styles.menuItemContainer}
              >
                <div
                  onClick={() => handlePageMove(menu.pageSlug)}
                  className={styles.menuItemClickable + " " + (isActive ? styles.active : '')}
                >
                  <InnocodeList
                    size="sm"
                    leadingIcon={true}
                    trailingIcon={true}
                    status={isMenuActive(menu) ? "pressed" : "default"}
                    borderRadius='12px'
                  >
                    <p className={styles.menuNameText}>{menu.pageName}</p>
                  </InnocodeList>
                </div>
              </div>
            );
          })}
        </div>
      </div> 
    </div>
  );
}

